module.exports = __webpack_public_path__ + "static/media/Dried_Kelp_Fronds.cf17054b.webp";